export default __webpack_public_path__ + "static/media/Ballroll_00299.597116c5.png";